document.addEventListener("DOMContentLoaded", function () {
    const isWideScreen = window.matchMedia("(min-width: 1024px)").matches;

    const swiper = new Swiper('.header-slider', {
        loop: true,
        effect: isWideScreen ? 'fade' : 'slide',
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // Enable autoplay
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            1024: {
                effect: 'fade'
            }
        }
    });
});
